import "./style.css";

export default class ArticleMembersSlider {
  static selector = ".article__members-slider";
  constructor(block) {
    this.block = block;
    this.slidesContainer = this.block.querySelector(
      ".article__members-slider-slides"
    );

    this.activeIndex = 0;

    this.slidesContainer.addEventListener("touchstart", this.handlePointerDown);
    this.slidesContainer.addEventListener("mousedown", this.handlePointerDown);

    this.autoPlayTimer = setInterval(() => {
      this.activeIndex =
        (this.activeIndex + 1) % this.slidesContainer.children.length;
      this.slidesContainer.style.transform = `translateX(${this.activeIndex *
        -100}%)`;
    }, 5000);
  }

  handlePointerMove = e => {
    const x = e.type === "touchmove" ? e.touches[0].clientX : e.clientX;
    const diff = this.startX - x;

    this.slidesContainer.style.transform = `translateX(${this.activeIndex *
      -100}%) translateX(${-diff}px)`;
  };

  handlePointerUp = e => {
    this.block.classList.remove("article__members-slider--is-dragging");

    const x = e.type === "touchend" ? e.changedTouches[0].clientX : e.clientX;
    let diff = this.startX - x;

    if (diff > this.slidesContainer.offsetWidth / 2) {
      this.activeIndex = Math.min(
        this.activeIndex + 1,
        this.slidesContainer.children.length - 1
      );
    } else if (diff < -this.slidesContainer.offsetWidth / 2) {
      this.activeIndex = Math.max(this.activeIndex - 1, 0);
    }

    this.slidesContainer.style.transform = `translateX(${this.activeIndex *
      -100}%)`;

    window.removeEventListener("touchmove", this.handlePointerMove);
    window.removeEventListener("mousemove", this.handlePointerMove);
    window.removeEventListener("touchend", this.handlePointerUp);
    window.removeEventListener("mouseup", this.handlePointerUp);

    this.autoPlayTimer = setInterval(() => {
      this.activeIndex =
        (this.activeIndex + 1) % this.slidesContainer.children.length;
      this.slidesContainer.style.transform = `translateX(${this.activeIndex *
        -100}%)`;
    }, 5000);
  };
  handlePointerDown = e => {
    clearInterval(this.autoPlayTimer);

    const x = e.type === "touchstart" ? e.touches[0].clientX : e.clientX;
    this.startX = x;
    this.block.classList.add("article__members-slider--is-dragging");

    console.log(this.slidesContainer, x);

    window.addEventListener("touchmove", this.handlePointerMove);
    window.addEventListener("mousemove", this.handlePointerMove);
    window.addEventListener("touchend", this.handlePointerUp);
    window.addEventListener("mouseup", this.handlePointerUp);
  };
}
